import { Card, CardContent } from "./ui/card";
import { Badge } from "./ui/badge";
import { MapPin, Bed, Bath, Lock, Zap } from "lucide-react";
import { PropertyImage } from "./PropertyImage";

const LockedPropertyCard = ({ property, onUpgrade }) => {
  return (
    <Card 
      className="bg-card border border-border rounded-xl overflow-hidden animate-fade-in relative group"
      data-testid={`locked-card-${property.id}`}
    >
      <div className="relative">
        <PropertyImage
          property={property}
          alt="Property"
          imgClassName="w-full h-48 object-cover blur-[6px] brightness-50"
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <Lock className="w-10 h-10 text-white/70" />
        </div>
      </div>
      <CardContent className="p-5">
        <div className="blur-sm select-none pointer-events-none">
          <h3 className="font-semibold text-foreground mb-1">Hidden Address</h3>
          <p className="text-sm text-muted-foreground flex items-center gap-1 mb-4">
            <MapPin className="w-3 h-3" /> {property.city}, {property.state}
          </p>
          <div className="flex items-center gap-4 text-sm text-muted-foreground mb-4">
            <span className="flex items-center gap-1"><Bed className="w-4 h-4" /> -- beds</span>
            <span className="flex items-center gap-1"><Bath className="w-4 h-4" /> -- baths</span>
          </div>
        </div>
        <button
          onClick={onUpgrade}
          className="w-full mt-2 flex items-center justify-center gap-2 py-2.5 rounded-lg bg-gradient-to-r from-emerald-500 to-teal-500 text-white text-sm font-semibold hover:from-emerald-600 hover:to-teal-600 transition-all"
          data-testid="upgrade-btn"
        >
          <Zap className="w-4 h-4" /> Unlock with Pro
        </button>
      </CardContent>
    </Card>
  );
};

export default LockedPropertyCard;
